import { useTableTemplateStore } from "../../store/tableTemplateStore";
import {
  buildHeaderRows,
  getLeafColumns,
  getLeafColumnWidthMap,
} from "./tableBuilderUtils/previewUtils";

export default function TablePreview() {
  const schema = useTableTemplateStore((s) => s.editorSchema);

  const preparedColumns = schema?.columns ?? [];
  const leafColumns = getLeafColumns(preparedColumns);
  const headerRows = buildHeaderRows(preparedColumns);
  const leafWidthMap = getLeafColumnWidthMap(preparedColumns);

  if (!schema) return null;

  if (!preparedColumns.length) {
    return (
      <div className="table-preview-card">
        <div className="panel-title">Live Preview</div>
        <div className="table-preview-canvas">
          <div className="table-preview-page">
            <div className="table-preview-margins">
              <div className="panel-empty">Add columns to see the table preview.</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const justifyContent =
    schema.alignment === "center"
      ? "center"
      : schema.alignment === "right"
      ? "flex-end"
      : "flex-start";

  return (
    <div className="table-preview-card">
      <div className="panel-title">Live Preview</div>
      <div className="table-preview-canvas">
        <div className="table-preview-page">
          <div className="table-preview-margins">
            <div className="table-preview-shell" style={{ justifyContent }}>
              <table className="table-preview-table" style={{ width: schema.width || "100%" }}>
                <colgroup>
                  {leafColumns.map((col) => (
                    <col
                      key={`preview-col-${col.id}`}
                      style={
                        leafWidthMap[col.id]
                          ? { width: `${leafWidthMap[col.id]}%` }
                          : undefined
                      }
                    />
                  ))}
                </colgroup>
                <thead>
                  {headerRows.map((row, rowIndex) => (
                    <tr key={`header-row-${rowIndex + 1}`}>
                      {row.map((cell) => (
                        <th
                          key={cell.id}
                          colSpan={cell.colSpan}
                          rowSpan={cell.rowSpan}
                          style={cell.width ? { width: `${cell.width}%` } : undefined}
                        >
                          {cell.header}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  <tr>
                    {leafColumns.map((col, index) => (
                      <td
                        key={col.id}
                        style={
                          {
                            ...(leafWidthMap[col.id]
                              ? { width: `${leafWidthMap[col.id]}%` }
                              : {}),
                            ...(col.align
                              ? { textAlign: col.align as "left" | "center" | "right" }
                              : {}),
                            ...(col.wrap
                              ? {
                                  whiteSpace: "normal",
                                  overflowWrap: "anywhere",
                                  wordBreak: "break-word",
                                }
                              : {
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }),
                          }
                        }
                      >
                        {col.wrap
                          ? `${col.key || col.header || `Column ${index + 1}`} sample content that wraps inside the cell border`
                          : `${col.key || col.header || `Column ${index + 1}`} value`}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
